import "@progress/kendo-theme-material/dist/all.css";
import { Fragment, Suspense } from "react";
import { CookiesProvider } from "react-cookie";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import RootComponent from "./components/home";
import Pace from "./components/shared/Pace";
import Notify from "./components/shared/wrappers/notify";
import store, { persistor } from "./store";
import { trimTrailingSlashes } from "./utils/stringUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
function App(): JSX.Element {
  const configuredBasePath = (process.env.REACT_APP_BASEPATH ?? "").trim();
  const normalizedBasePath =
    configuredBasePath && configuredBasePath !== "/"
      ? trimTrailingSlashes(configuredBasePath)
      : "";
  // Only apply basename when the current URL actually lives under REACT_APP_BASEPATH.
  // If we always set basename=/icportal while the user opens /login or /portal/home (no
  // /icportal prefix), React Router v6 will not match any route and the login shell fails
  // to render. Leave basename undefined for root-style URLs; use /icportal/... when you
  // need the hosted-base-path deployment shape.
  const routerBaseName =
    normalizedBasePath &&
    window.location.pathname
      .toLowerCase()
      .startsWith(normalizedBasePath.toLowerCase())
      ? normalizedBasePath
      : undefined;

  return (
    <BrowserRouter basename={routerBaseName}>
      <Pace color="#79e0fc" />
      <Suspense fallback={<Fragment />}>
        <Provider store={store}>
          <CookiesProvider>
            <PersistGate loading={null} persistor={persistor}>
              <RootComponent />
              <Notify />
            </PersistGate>
          </CookiesProvider>
        </Provider>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
